import { Accordion } from '@design/components/accordion/Accordion';
import { ButtonLink } from '@design/components/button-link/ButtonLink';
import { useDocumentSections } from '@terminal/react-query-hooks/documents/useDocumentsEntity';
import {
  CitationsDrawer,
  SelectedCitation,
} from '@terminal/widgets/citations-accordion-widget/citations-drawer/CitationsDrawer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './SourceEvidenceSectionRevamp.module.scss';

interface SourceEvidenceSectionRevampProps {
  evidence?: string[] | null;
  sourceEvidence?: string | null;
}

export const SourceEvidenceSectionRevamp = ({
  evidence,
  sourceEvidence,
}: SourceEvidenceSectionRevampProps) => {
  const { t } = useTranslation(['widget']);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedCitation, setSelectedCitation] = useState<SelectedCitation>();
  const { data: citations } = useDocumentSections(evidence ?? []);

  if (!sourceEvidence) {
    return null;
  }

  return (
    <div className={styles.sectionRow}>
      <Accordion
        withBackground={false}
        className={styles.accordion}
        items={[
          {
            title: t(
              'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.sourceEvidence'
            ),
            expandedByDefault: true,
            content: (
              <div className={styles.content}>
                <div className={styles.description} data-testid="evidence">
                  {sourceEvidence}
                </div>
                {citations.length > 0 && (
                  <ButtonLink
                    className={styles.viewCitations}
                    data-testid="view-citations"
                    label={t(
                      'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.viewCitations'
                    )}
                    onClick={() => setIsDrawerOpen(true)}
                  />
                )}
              </div>
            ),
          },
        ]}
      />
      <CitationsDrawer
        citations={citations}
        isOpen={isDrawerOpen}
        onClose={() => {
          setIsDrawerOpen(false);
          setSelectedCitation(undefined);
        }}
        onSelectCitation={setSelectedCitation}
        selectedCitation={selectedCitation}
      />
    </div>
  );
};
